export const RENDER_ACITIVITY_FORM_STATUS = (key) => {
  switch (key) {
    case "0":
      return {
        label: "Registration unsuccessful",
        bgColor: "#FF8900",
        txtColor: "#FFFFFF",
      };
    case "1":
      return {
        label: "รอการตรวจสอบจากแอดมิน",
        bgColor: "#FEDB04",
        txtColor: "#4B1E78",
      };
    case "2":
      return {
        label: "Rejected",
        bgColor: "#FFFFFF",
        txtColor: "",
      };
    case "3":
      return {
        label: "Rejected by Customer",
        bgColor: "#FF0000",
        txtColor: "",
      };
    case "4":
      return {
        label: "การลงทะเบียนสำเร็จแล้ว",
        bgColor: "#0FB863",
        txtColor: "#FFFFFF",
      };
    case "5":
      return {
        label: "ฉบับร่าง",
        bgColor: "#FEDB04",
        txtColor: "#4B1E78",
      };
    case "6":
      return {
        label: "รอแอดมินแก้ไขข้อมูล",
        bgColor: "#FF8900",
        txtColor: "#FFFFFF",
      };
    case "7":
      return {
        label: "ข้อมูลได้รับการแก้ไขแล้ว",
        bgColor: "#FF8900",
        txtColor: "#FFFFFF",
      };
    default:
      return false;
  }
};
